import { render, staticRenderFns } from "./AddProductByCat.vue?vue&type=template&id=90ee234a&scoped=true&"
import script from "./AddProductByCat.vue?vue&type=script&lang=ts&"
export * from "./AddProductByCat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ee234a",
  null
  
)

export default component.exports